import { useCallback, useState } from 'react'
import { useRejectTimeEntry } from '@/hooks/useRejectTimeEntry'
import type { TimeEntriesExpanded } from '@/types/timeTracking'

export function useRejectDialog() {
    const [rejectingEntry, setRejectingEntry] = useState<TimeEntriesExpanded | null>(null)
    const rejectMutation = useRejectTimeEntry()

    const openDialog = useCallback((entry: TimeEntriesExpanded) => {
        setRejectingEntry(entry)
    }, [])

    const closeDialog = useCallback(() => {
        setRejectingEntry(null)
    }, [])

    const confirmReject = useCallback(
        async (reason: string) => {
            if (!rejectingEntry) return

            try {
                await rejectMutation.mutateAsync({
                    entryId: rejectingEntry.id,
                    orgId: rejectingEntry.org,
                    reason,
                })
                closeDialog()
            } catch (_error) {
                // Error is captured in the mutation hook
            }
        },
        [rejectingEntry, rejectMutation, closeDialog]
    )

    return {
        isOpen: !!rejectingEntry,
        isLoading: rejectMutation.isPending,
        openDialog,
        closeDialog,
        confirmReject,
    }
}
